module.exports = __webpack_public_path__ + "static/media/zhong@3x.c6c05cc8.png";